import React, { useContext } from "react";
import { usePlaidLink } from "react-plaid-link";
import { PlaidContext } from "../context/PlaidContext";
import { useNavigate } from "react-router-dom";
import { plaidApi } from "../services/plaidApi";

const Link = () => {
  const { linkToken, dispatch } = useContext(PlaidContext);
  const navigate = useNavigate();

  const onSuccess = async (public_token: string) => {
    try {
      const data = await plaidApi.setAccessToken(public_token);
      localStorage.setItem("access_token", data.access_token);
      dispatch({ type: "SET_ACCESS_TOKEN", payload: data.access_token });
      navigate("/dashboard");
    } catch (error) {
      console.error(error);
    }
  };

  const { open, ready } = usePlaidLink({
    token: linkToken || "",
    onSuccess,
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="flex w-full max-w-4xl rounded-lg shadow-lg overflow-hidden">
        {/* Left Panel - Purple */}
        <div className="w-1/2 bg-gradient-to-br from-blue-600 to-purple-700 text-white p-12 flex flex-col justify-between">
          <div>
            <h1 className="text-4xl font-bold mb-4">Plaid Connect</h1>
            <p className="text-lg text-blue-100 mb-12">
              Connect your bank account securely with Plaid. Fast, reliable, and trusted by millions.
            </p>

            {/* Features */}
            <div className="space-y-8">
              {/* Feature 1 */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-blue-500 bg-opacity-50">
                    <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-xl font-bold">Bank-Level Security</h3>
                  <p className="text-blue-100 mt-1">Enterprise-grade encryption to protect your data</p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-blue-500 bg-opacity-50">
                    <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-xl font-bold">Instant Connection</h3>
                  <p className="text-blue-100 mt-1">Connect in seconds with our seamless flow</p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-blue-500 bg-opacity-50">
                    <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4 mb-4">
                  <h3 className="text-xl font-bold">Verified Data</h3>
                  <p className="text-blue-100 mt-1">Accurate and up-to-date financial information</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm text-blue-100 border-t border-blue-400 pt-4">
            Trusted by leading financial institutions worldwide
          </p>
        </div>

        {/* Right Panel - White */}
        <div className="w-1/2 bg-white p-12 flex flex-col justify-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-2">Connect Account</h2>
          <p className="text-gray-600 text-lg mb-12">Link your bank account to get started</p>

          {/* Button */}
          <button
            onClick={() => open()}
            disabled={!ready}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-700 hover:from-blue-700 hover:to-purple-800 disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold py-4 px-6 rounded-lg transition-all duration-200 text-lg"
          >
            Connect Bank Account
          </button>

          <p className="text-center text-gray-500 text-sm mt-8">
            Your connection is encrypted and secured by industry-standard protocols
          </p>
        </div>
      </div>
    </div>
  );
};

export default Link;
